import Header from '../components/Header';

import ScoreCards from '../components/ScoreCards';

import OrderChart from '../components/Charts/Order';
import UserInformationChart from '../components/Charts/UserInformation';

import OrdersCountChart from  '../components/Charts/OrdersCount';
import SoldProductsChart from '../components/Charts/SoldProducts';
import TopWholesaleCustomer from '../components/Charts/TopWholesaleCustomer';

import RegistrationTable from '../components/Tables/Registration';
import OrdersTable from '../components/Tables/Orders';

import { useDashboard } from '../context/DashboardContext';

export default function Dashboard() {

    const { data, isLoading } = useDashboard();

    return (
        <div className='analytics-dashboard'>
            <Header />
            <div className="wholesale-dashboard-body-wrapper">
                <ScoreCards loadingState={isLoading} response={data.scoreCards} />

                <div className="dashboard-chart-section-1 flex justify-between">
                    <OrderChart loadingState={isLoading} response={data.chart} />
                    <UserInformationChart loadingState={isLoading} response={data.requests} />
                </div>
                <div className="dashboard-chart-section-2 flex justify-between">
                    <OrdersCountChart loadingState={isLoading} response={data.ordersCount} />
                    <SoldProductsChart loadingState={isLoading} response={data.topProducts} />
                    <TopWholesaleCustomer loadingState={isLoading} response={data.topCustomers} />
                </div>
                <hr class="w-full h-1 mx-auto my-4 bg-gray-100 border-0 rounded-sm" />
                <div className="dashboard-tables">
                    <RegistrationTable loadingState={isLoading} response={data.recentRequests} redirect={data?.redirects?.requests} />
                    <OrdersTable loadingState={isLoading} response={data.recentOrders}  redirect={data?.redirects?.orders} />
                </div>
            </div>
        </div>
    );
};